import * as React from 'react';

import { EUserRole, MembershipStatus } from '@/graphql-types/globalTypes';
import { IEventTicketsCurrentUserCanPurchase } from '@/imports/ui/components/Cart/TypeDefs';

import {
  checkEligibility,
  checkEventVisibility,
} from '../components/ticketUtils';
import { TicketSelect_EventFragment } from '../graphql/graphql-types/TicketSelect_EventFragment';

export const useTicketEligibility = (
  event: IEventTicketsCurrentUserCanPurchase | undefined,
  user: any,
  hasMembershipInCart: boolean,
  userGroupIds: string[],
  registrationsData: any,
  isFromInvoice?: boolean,
  hasMembershipInInvoice?: boolean
) => {
  const isAuthenticated = !!user;
  /** Tradewing membership term status, or AMS/integration-backed member flag */
  const isMember =
    user?.membershipData?.membershipStatus === MembershipStatus.MEMBER ||
    user?.integrationIsMember === true;
  const isAdmin =
    user?.role === EUserRole.ADMIN || user?.role === EUserRole.MORGOTH;
  const userId = user?._id;

  const baseEvent = event as unknown as TicketSelect_EventFragment | undefined;
  const eventVisibility = baseEvent?.visibility;
  const eventVisibilityType = eventVisibility?.type;
  const eventGroupIds = eventVisibility?.groupIds || [];
  const eventUserIds = eventVisibility?.userIds || [];

  const getEligibilityForTicket = React.useCallback(
    (ticket: any) =>
      checkEligibility(
        ticket,
        eventVisibilityType,
        eventGroupIds,
        eventUserIds,
        isAuthenticated,
        isMember,
        hasMembershipInCart,
        isAdmin,
        userGroupIds,
        userId,
        isFromInvoice,
        hasMembershipInInvoice
      ),
    [
      eventVisibilityType,
      eventGroupIds,
      eventUserIds,
      isAuthenticated,
      isMember,
      hasMembershipInCart,
      isAdmin,
      userGroupIds,
      userId,
      isFromInvoice,
      hasMembershipInInvoice,
    ]
  );

  const getEventVisibilityCheck = React.useCallback(
    () =>
      checkEventVisibility(
        eventVisibilityType,
        eventGroupIds,
        eventUserIds,
        isAuthenticated,
        isMember,
        hasMembershipInCart,
        userGroupIds,
        userId
      ),
    [
      eventVisibilityType,
      eventGroupIds,
      eventUserIds,
      isAuthenticated,
      isMember,
      hasMembershipInCart,
      userGroupIds,
      userId,
    ]
  );

  return {
    getEligibilityForTicket,
    getEventVisibilityCheck,
    isAuthenticated,
    isMember,
    isAdmin,
    userId,
  };
};
